module.exports = __webpack_public_path__ + "static/img/page3.e740693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/page3.png
// module id = DjAJ
// module chunks = 2